const MAX_SEEN = 200;

export class DedupeSeenEvents {
  private readonly order: string[] = [];
  private readonly seen = new Set<string>();

  has(id: string): boolean {
    return this.seen.has(id);
  }

  remember(id: string): void {
    if (this.seen.has(id)) return;
    this.seen.add(id);
    this.order.push(id);
    while (this.order.length > MAX_SEEN) {
      const oldest = this.order.shift();
      if (oldest) this.seen.delete(oldest);
    }
  }
}
